import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { FlexPrivate } from './flex.esm.js';

var FlexInlinePrivate = /*#__PURE__*/React.forwardRef(function FlexInlinePrivate(props, ref) {
  return /*#__PURE__*/React.createElement(FlexPrivate, _extends({
    ref: ref
  }, props, {
    inline: true
  }));
});
var FlexInline = /*#__PURE__*/React.forwardRef(function FlexInline(props, ref) {
  return /*#__PURE__*/React.createElement(FlexInlinePrivate, _extends({
    ref: ref
  }, props));
});

export default FlexInline;
export { FlexInlinePrivate };
//# sourceMappingURL=flex-inline.esm.js.map
